export interface ActorProfile {
  name: string;
  avatar: string;
  intro: string;
}

export const actors: ActorProfile[] = [
  {
    name: "林知夏",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Asian%20actress%20with%20calm%20expression%20and%20soft%20natural%20window%20light%2C%20warm%20beige%20neutral%20background%2C%20minimal%20cinematic%20headshot%2C%20high%20detail&width=400&height=400&seq=actor-01&orientation=squarish",
    intro: "以细腻克制的表演见长，擅长处理大量内心戏，被观众称为“沉默的情绪放大器”。",
  },
  {
    name: "沈亦白",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Asian%20actor%20with%20short%20dark%20hair%20and%20quiet%20gaze%2C%20soft%20grey%20beige%20studio%20background%2C%20minimal%20cinematic%20headshot%2C%20subtle%20warm%20light%2C%20high%20detail&width=400&height=400&seq=actor-02&orientation=squarish",
    intro: "从舞台剧出身，台词功底扎实，近年在文艺片中的表现被认为是他最好的状态。",
  },
  {
    name: "周慕云",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20mature%20Asian%20actor%20with%20slight%20stubble%20and%20serious%20expression%2C%20muted%20slate%20grey%20studio%20background%2C%20minimal%20cinematic%20headshot%2C%20moody%20side%20lighting%2C%20high%20detail&width=400&height=400&seq=actor-03&orientation=squarish",
    intro: "悬疑题材的常客，身上自带一种“知道太多”的疲惫感，是导演们最信任的类型演员。",
  },
  {
    name: "苏晚",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Asian%20actress%20with%20long%20dark%20hair%20and%20a%20gentle%20smile%2C%20soft%20cream%20neutral%20background%2C%20minimal%20cinematic%20headshot%2C%20warm%20diffused%20light%2C%20high%20detail&width=400&height=400&seq=actor-04&orientation=squarish",
    intro: "都市剧领域的稳定输出者，擅长把普通人的犹疑演得让人信服。",
  },
  {
    name: "顾南川",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20middle%20aged%20Asian%20actor%20with%20warm%20tired%20eyes%2C%20plain%20beige%20studio%20background%2C%20minimal%20cinematic%20headshot%2C%20soft%20directional%20light%2C%20high%20detail&width=400&height=400&seq=actor-05&orientation=squarish",
    intro: "以家庭题材见长，一个眼神就能带出角色的半生故事，被称作“国民父亲”。",
  },
  {
    name: "叶清和",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20an%20elegant%20Asian%20actress%20in%20her%20forties%20with%20short%20hair%2C%20soft%20sand%20colored%20background%2C%20minimal%20cinematic%20headshot%2C%20natural%20window%20light%2C%20high%20detail&width=400&height=400&seq=actor-06&orientation=squarish",
    intro: "年代戏中的定海神针，处理生活化细节极其精准，几乎不需要台词就能交代人物。",
  },
  {
    name: "江予安",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20middle%20aged%20Asian%20actor%20with%20glasses%20and%20a%20calm%20expression%2C%20muted%20warm%20grey%20background%2C%20minimal%20cinematic%20headshot%2C%20soft%20studio%20lighting%2C%20high%20detail&width=400&height=400&seq=actor-07&orientation=squarish",
    intro: "戏剧圈的老面孔，近年因一系列“话不多的中年人”角色被更多观众记住。",
  },
  {
    name: "唐亦然",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Asian%20actor%20with%20sharp%20features%20and%20neutral%20expression%2C%20cool%20light%20grey%20studio%20background%2C%20minimal%20cinematic%20headshot%2C%20strong%20soft%20shadow%2C%20high%20detail&width=400&height=400&seq=actor-08&orientation=squarish",
    intro: "动作与类型片的年轻力量，近年主动挑战更复杂的角色，进步速度肉眼可见。",
  },
  {
    name: "许星野",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Asian%20actor%20with%20messy%20dark%20hair%20and%20relaxed%20smile%2C%20light%20warm%20beige%20background%2C%20minimal%20cinematic%20headshot%2C%20natural%20soft%20light%2C%20high%20detail&width=400&height=400&seq=actor-09&orientation=squarish",
    intro: "青春题材出身，气质干净，近年在悬疑剧中成功转型，戏路明显变宽。",
  },
  {
    name: "温梨",
    avatar:
      "https://readdy.ai/api/search-image?query=Editorial%20portrait%20of%20a%20young%20Asian%20actress%20with%20wavy%20hair%20and%20bright%20friendly%20eyes%2C%20soft%20cream%20background%2C%20minimal%20cinematic%20headshot%2C%20gentle%20warm%20light%2C%20high%20detail&width=400&height=400&seq=actor-10&orientation=squarish",
    intro: "擅长轻盈自然的日常表演，是治愈系作品里最让人放松的那张脸。",
  },
];

export const actorProfiles: Record<string, ActorProfile> = {
  林知夏: actors[0],
  沈亦白: actors[1],
  周慕云: actors[2],
  苏晚: actors[3],
  顾南川: actors[4],
  叶清和: actors[5],
  江予安: actors[6],
  唐亦然: actors[7],
  许星野: actors[8],
  温梨: actors[9],
};